var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"flex items-center justify-between mt-2"},[_c('page-header',{attrs:{"heading":"Wallet","breadcrumb":"Settings  >>  Payments >>  Wallet"}})],1),(_vm.isEmpty)?_c('empty-wallet'):_c('wallet')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }